import { messages } from '@/utils';
import axios from '@/utils/axios';
import * as types from '../mutations-types';

const state = {
    loading: false,
    laboratorios: []
};

const getters = {};

const mutations = {
    [types.LOADING](state, value) {
        state.loading = typeof value !== 'undefined' ? value : true;
    },
    [types.SET_LABORATORIOS](state, labs) {
        state.laboratorios = labs;
    }
};

const actions = {
    async getLaboratorios({ commit }, filtered = []) {
        try {
            commit(types.LOADING);
            const { status, data } = await axios.get('/laboratorios', {
                params: { filtered }
            });
            const laboratorios = data.data;
            if (status === 200) {
                commit(types.SET_LABORATORIOS, laboratorios);
            }
            return { data: laboratorios };
        } catch ({ status, error }) {
            return {
                error:
                    status === 403 ? 'Debe iniciar Sesión.' : messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
